import { gql } from "@apollo/client";

export const GET_SENT_NOTIFICATIONS = gql`
	query getSentNotifications(
		$limit: Int
		$offset: Int
		$order_by: msgbox_BroadcastContact_order_by!
		$where: msgbox_BroadcastContact_bool_exp!
	) {
		msgbox_BroadcastContact(
			limit: $limit
			offset: $offset
			order_by: [$order_by]
			where: $where
		) {
			CreatedBy
			CreatedOn
			ContactId
			Contact {
				Name
				MobileNumber
				ContactId
				Status
			}
			BroadcastId
			Broadcast {
				AttachmentId
				TemplateId
				APIAccountId
				Message
				Template {
					Name
					TemplateId
				}
				BroadcastContacts {
					Message {
						SendFailureReason
					}
				}
			}
			BroadcastContactStatus {
				Status
			}
		}
		msgbox_BroadcastContact_aggregate(where: $where) {
			aggregate {
				count
			}
		}
	}
`;
